import { OrderService } from "../services";


export class OrderInterface {
    shopId: number;
    itemList: OrderItemInterface[];

    constructor() {
        this.shopId = Number(OrderService.shop.getValue());
        this.itemList = [];
    }
}

export interface OrderItemInterface {
    article: {
        barcode?: string;
        quantity: number;
        id?: string;
    }

}
